import router from "@/router"
import SessaoServico from "@/servicos/sessao.service"

const naoFazerNada = (): void => undefined
const redirecionarPeloNavegador = (url: string): void =>
  window.location.assign(url)

export function construirUrlDeLogoutKeycloak(): string | null {
  if (
    !SessaoServico.ehSessaoKeycloak ||
    !SessaoServico.urlLogoutKeycloak ||
    !process.env.VUE_APP_KEYCLOAK_BASE_URL
  ) {
    return null
  }

  try {
    const url = new URL(SessaoServico.urlLogoutKeycloak)
    const baseUrlConfiavel = new URL(process.env.VUE_APP_KEYCLOAK_BASE_URL)
      .toString()
      .replace(/\/$/, "")

    return url.toString().startsWith(`${baseUrlConfiavel}/realms/`)
      ? url.toString()
      : null
  } catch {
    return null
  }
}

export function encerrarSessaoAutenticada(
  limparEstadoDaAplicacao: () => void = naoFazerNada,
  redirecionarParaUrlExterna: (url: string) => void = redirecionarPeloNavegador
): void {
  const urlDeLogoutKeycloak = construirUrlDeLogoutKeycloak()

  SessaoServico.limparInformacoesDaSessao()
  limparEstadoDaAplicacao()

  if (urlDeLogoutKeycloak) {
    redirecionarParaUrlExterna(urlDeLogoutKeycloak)
    return
  }

  void router.push({ name: "Login" })
}
